import { z } from 'zod';
export const DSLPrefixQueryDTO = z.object({
  prefix: z.record(z.string(), z.string()),
});

export type DSLPrefixQuery = z.infer<typeof DSLPrefixQueryDTO>;